export class PhoneVerificationVerifyModel {
    userId: string | null = null;
    code: string | null = null;

    constructor(data?: Partial<PhoneVerificationVerifyModel>) {
        Object.assign(this, data);
    }
}
